import { render, staticRenderFns } from "./PostsCarousel.vue?vue&type=template&id=154874b2&scoped=true&"
import script from "./PostsCarousel.vue?vue&type=script&lang=ts&"
export * from "./PostsCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PostsCarousel.vue?vue&type=style&index=0&id=154874b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154874b2",
  null
  
)

export default component.exports